import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/person.svg'
import _imports_1 from '@/assets/icons/mail.svg'


const _withScopeId = n => (_pushScopeId("data-v-0ef13bc2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-section" }
const _hoisted_2 = { class: "form-section__form form" }
const _hoisted_3 = { class: "form__input" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "form__input-icon",
  src: _imports_0
}, null, -1))
const _hoisted_5 = { class: "form__input" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "form__input-icon",
  src: _imports_1
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives(_createElementVNode("input", {
          class: "form__input-field",
          type: "text",
          placeholder: "Ваше имя",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event))
        }, null, 512), [
          [_vModelText, _ctx.name]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _withDirectives(_createElementVNode("input", {
          class: "form__input-field",
          type: "text",
          placeholder: "Ваш почтовый адрес",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.email) = $event))
        }, null, 512), [
          [_vModelText, _ctx.email]
        ])
      ]),
      _withDirectives(_createElementVNode("textarea", {
        class: "form__textarea",
        placeholder: "Задайте нам любой вопрос, который Вас интересует",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.question) = $event))
      }, null, 512), [
        [_vModelText, _ctx.question]
      ]),
      _createElementVNode("div", {
        class: "form__submit-btn landing__button--primary",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.sendFormData()))
      }, "Задать вопрос ")
    ])
  ]))
}